export const SET_COLUMNS = 'SET_COLUMNS'
export const RESET_COLUMNS = 'RESET_COLUMNS'
export const SET_FILTER_TABULAR = 'SET_FILTER_TABULAR'
export const RESET_FILTER_COLUMNS = 'RESET_FILTER_COLUMNS'